import React, { useState, useContext } from 'react';
import BackButton from './BackButton';
import AntCoinImg from './images/AntCoin.png';
import PrizeImg from './images/Icon_Trophy.png';
import LotteryTicketImg from './images/LotteryTicket.png';
import pastdraws from './Pastlottery.js';

function Lottery({ goBack, changeActiveComponent }) {
    const [selectedItem, setSelectedItem] = useState(null);

    const handleItemClick = (item) => {
      setSelectedItem(item);
    };

    return (
        <section id="nestwars">
          <div className="newui-container">
          <div className="platform-container">
            <button className="lottery-rules-button">INFO/RULES</button>
            <div className="inventory-container" id="lottery-container">
              <div className="lottery-container-full-left">
                <div className="inventory-container-left" id="lottery-left">
                    <p className="lottery-info-pp">Total Prize Pool</p>
                    <div className="lottery-total-prize"><h1>$17,823.00</h1></div>
                    <p className="lottery-info-p">Time to Draw</p>
                    <div className="lottery-timer-container">
                        <div className="lottery-timer-box"><h2>02</h2><p>days</p></div>
                        <div className="lottery-timer-box"><h2>10</h2><p>hours</p></div>
                        <div className="lottery-timer-box"><h2>13</h2><p>minutes</p></div>
                        <div className="lottery-timer-box"><h2>17</h2><p>seconds</p></div>
                    </div>
                    <button className="lottery-button" id="assign" onClick={() => changeActiveComponent('shop')}>BUY TICKETS</button>
                    </div>
                    <div className="pastdraws-container"></div>
                    </div>
                    <div className="inventory-container-right">
                     <div className="lottery-title-container"><h1>Your Tickets</h1></div>
                        <div className="lottery-tickets-container">
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                            <div className="lottery-ticket-holder"><img src={LotteryTicketImg}/></div>
                        </div>
                </div>
                </div>
    </div> 
    </div>
        </section>
      );
    }
    
    export default Lottery;